<template>
  <aside>
    <h6>Followers</h6>
    <section class="metrics lime lighten-4 left-align" v-show="isAnalyst">
      <strong>Avg. Analyst: </strong>
      <span class="strong" :class="avgAnalystRating >= 0 ? 'green-text' : 'red-text'">{{ avgAnalystRating }}</span>
    </section>
    <section class="metrics orange lighten-4 left-align">
      <strong>Avg. Farm Team: </strong>
      <span class="strong" :class="avgFarmTeamRating >= 0 ? 'green-text' : 'red-text'">{{ avgFarmTeamRating }}</span>
    </section>
    <section>
      Sort By:
      <p class="left-align" style="margin: 0px;">
        <label>
          <input type="radio" value="name" v-model="sortOrder">
          <span>Name</span>
        </label>
      </p>
      <p class="left-align" style="margin: 0px;">
        <label>
          <input type="radio" value="conviction" v-model="sortOrder">
          <span>Conviction</span>
        </label>
      </p>
    </section>
    <ul>
      <li class="follower left-align"
          v-for="follower of followers"
          :key="follower.id"
          v-show="isAnalyst || follower.analyst.roles.includes('farm-team')"
      >
        <router-link :to="`/analyst?analyst_id=${follower.analyst.id}`">
          <img class="circle clickable"
               :key="follower.id"
               :src="follower.analyst.avatar"
               alt=""
               height="20"
               style="position: relative; top:2px;"
          >
        </router-link>
        {{ follower.analyst.name }}
        <i class="pink-text text-lighten-3 fas fa-heart small" v-if="follower.points > 0" />
        <i class="grey-text text-lighten-2 fas fa-heart small" v-if="follower.points === 0" />
        <i class="blue-text text-accent-1 fas fa-heart-broken small" v-if="follower.points < 0" />
        {{ follower.points }}
      </li>
    </ul>
  </aside>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CompanyFollowers',
  props: {
    companyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      followersRaw: [],
      sortOrder: 'name',
    };
  },
  computed: {
    isAnalyst() {
      return this.$auth.hasRoles('analyst', 'adp');
    },
    followers() {
      return this.followersRaw.filter(follower => follower.analyst.active && !follower.analyst.is_tester);
    },
    avgAnalystRating() {
      const followers = this.followers.filter(follower => follower.analyst.roles.includes('analyst'));
      return (this.sum(followers.map(follower => follower.points)) / followers.length).toFixed(2);
    },
    avgFarmTeamRating() {
      const followers = this.followers.filter(follower => follower.analyst.roles.includes('farm-team'));
      return (this.sum(followers.map(follower => follower.points)) / followers.length).toFixed(2);
    },
  },
  watch: {
    sortOrder() {
      switch (this.sortOrder) {
        case 'name':
          this.sortArray(this.followersRaw, 'analyst.name');
          break;
        case 'conviction':
          this.sortArray(this.followersRaw, 'points', true);
          break;
        default:
          break;
      }
    },
  },
  methods: {},
  async mounted() {
    const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/companies/followers/?company_id=${this.companyId}`);
    this.followersRaw = data;
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.follower {
  border: 1px solid $tmf-gains;
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
}
.metrics {
  padding: 5px;
  padding-left: 20px;
  border: 1px solid white;
  border-radius: 10px;
}
</style>
